




























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import {
  BaseDocument,
  JinroRoomDocument,
  JinroPlayerStatisticsDocument,
} from "@/services/datatypes";
import JinroStatisticsTable from "@/components/shared/JinroStatisticsTable.vue";

@Component({
  components: {
    JinroStatisticsTable,
  },
})
export default class JinroRoomRankings extends Vue {
  @Prop() readonly refCollection!: firebase.firestore.CollectionReference;
  detacher?: firebase.Unsubscribe;
  jinroRooms: Array<JinroRoomDocument> | null = null;

  lastGameEnded(date: any): string {
    if (!date) {
      return "";
    }
    return date.toDate().toLocaleString();
  }
  getSelectedPlayerId(statistics: Array<JinroPlayerStatisticsDocument>) {
    const stat = statistics.find((stat) => {
      return stat.playerUid === this.$store.state.firebaseUser.uid;
    });
    if (stat) {
      return stat.playerId;
    }
    return "";
  }

  created() {
    this.detacher = this.refCollection
      .orderBy("timeCreated", "desc")
      .where("owner", "==", this.$store.state.firebaseUser.uid)
      .onSnapshot((snapshot) => {
        this.jinroRooms = snapshot.docs.map((doc) => {
          return Object.assign(doc.data(), { id: doc.id }) as JinroRoomDocument;
        });
        const rankingLength = this.jinroRooms.filter((jinroRoom) => {
          return jinroRoom.jinroRoomPlayersStatistics;
        }).length;
        this.$emit("rankings-length", rankingLength);
      });
  }
  destroyed() {
    this.detacher && this.detacher();
  }
}
